module.exports = __webpack_public_path__ + "img/e6acf32.png";